export default __webpack_public_path__ + "static/media/employeeIcon.1f980711.svg";